export default {"src":"/_next/static/media/footerBackground.abcdc03f.svg","height":60,"width":1200};